if (window.CKEDITOR) {
	CKEDITOR.plugins.setLang( 'colorspanel', 'en', {
		auto: 'Automatic',
		bgColorTitle: 'Background Color',
		colors: {
			'000': 'Black',
			'800000': 'Maroon',
			'8B4513': 'Saddle Brown',
			'2F4F4F': 'Dark Slate Gray',
			'008080': 'Teal',
			'000080': 'Navy',
			'4B0082': 'Indigo',
			'696969': 'Dark Gray',
			'B22222': 'Fire Brick',
			'A52A2A': 'Brown',
			'DAA520': 'Golden Rod',
			'006400': 'Dark Green',
			'40E0D0': 'Turquoise',
			'0000CD': 'Medium Blue',
			'800080': 'Purple',
			'808080': 'Gray',
			'F00': 'Red',
			'FF8C00': 'Dark Orange',
			'FFD700': 'Gold',
			'008000': 'Green',
			'0FF': 'Cyan',
			'00F': 'Blue',
			'EE82EE': 'Violet',
			'A9A9A9': 'Dim Gray',
			'FFA07A': 'Light Salmon',
			'FFA500': 'Orange',
			'FFFF00': 'Yellow',
			'00FF00': 'Lime',
			'AFEEEE': 'Pale Turquoise',
			'ADD8E6': 'Light Blue',
			'DDA0DD': 'Plum',
			'D3D3D3': 'Light Grey',
			'FFF0F5': 'Lavender Blush',
			'FAEBD7': 'Antique White',
			'FFFFE0': 'Light Yellow',
			'F0FFF0': 'Honeydew',
			'F0FFFF': 'Azure',
			'F0F8FF': 'Alice Blue',
			'E6E6FA': 'Lavender',
			'FFF': 'White',
			'1ABC9C': 'Strong Cyan',
			'2ECC71': 'Emerald',
			'3498DB': 'Bright Blue',
			'9B59B6': 'Amethyst',
			'4E5F70': 'Grayish Blue',
			'F1C40F': 'Vivid Yellow',
			'16A085': 'Dark Cyan',
			'27AE60': 'Dark Emerald',
			'2980B9': 'Strong Blue',
			'8E44AD': 'Dark Violet',
			'2C3E50': 'Desaturated Blue',
			'F39C12': 'Orange',
			'E67E22': 'Carrot',
			'E74C3C': 'Pale Red',
			'ECF0F1': 'Bright Silver',
			'95A5A6': 'Light Grayish Cyan',
			'DDD': 'Light Gray',
			'D35400': 'Pumpkin',
			'C0392B': 'Strong Red',
			'BDC3C7': 'Silver',
			'7F8C8D': 'Grayish Cyan',
			'999': 'Dark Gray',
		},
		more: 'More Colors...',
		panelTitle: 'Colors',
		textColorTitle: 'Text Color',
	});
}
